import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import React from 'react'


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1),
    backgroundColor: 'white',
  },
}))


const TabPanel = ({
  hidden,
  children,
}) => {
  const classes = useStyles()

  return (
    <div
      role="tabpanel"
      hidden={hidden}
    >
      <div className={classes.root}>
        {!hidden && children}
      </div>
    </div>
  )
}


TabPanel.defaultProps = {
  hidden: false,
  children: [],
}


TabPanel.propTypes = {
  hidden: PropTypes.bool,
  children: PropTypes.node,
}


export default TabPanel
